import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import EngagingMenuImg from "../../images/engaging-menu.svg"
import PhotographyImg from "../../images/photography.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import EngagingMenuPageStyle from "./engaging-menu-page.module.scss"

const EngagingMenuSec1 = () => (
    <StaticQuery query={graphql`
        query EngagingMenuPageContent {
            contentfulEngagingMenuPage{
                engagingMenuReference{
                  sectionContent1{
                  subtitle{
                    subtitle
                  }
                  sectionParagraph{
                    json
                  }
                }
                sectionContent2{
                  subtitle{
                    subtitle
                  }
                  sectionParagraph{
                    json
                  }
                }
                sectionContent3{
                  subtitle{
                    subtitle
                  }
                  sectionParagraph{
                    json
                  }
                }
                }
              }
        }
    `}
    render={data =>(
    <div className={EngagingMenuPageStyle.sectionDiv}>

        {/* Features Links */}
        <Row className={EngagingMenuPageStyle.section1Features} id="parent-div">
            <Col xs={12}><h3 className={EngagingMenuPageStyle.sectionTitle}>Website Features</h3></Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EngagingMenuPageStyle.featuresBtn1} to="/essentials">The Essentials</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EngagingMenuPageStyle.featuresBtn2} to="/mobile-first">Mobile First</Link>
                </ScrollAnimation>    
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EngagingMenuPageStyle.featuresBtn3} to="/engaging-menu">Engaging Menu</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EngagingMenuPageStyle.featuresBtn4} to="/convenient-booking">Convenient Booking</Link>
                </ScrollAnimation>
                </div>
            </Col>
        </Row>
        {/* Section 1 Content */}
        <Row>
            <Col className={EngagingMenuPageStyle.engagingMenuSec1Col1} md={7} sm={6}>
                <h3 className={EngagingMenuPageStyle.sectionTitleLeftAlign}>{data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent1.subtitle.subtitle}</h3>
                <div className={EngagingMenuPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent1.sectionParagraph.json)}
                </div>
            </Col>
            <Col className={EngagingMenuPageStyle.engagingMenuSec1Col2} md={5} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <EngagingMenuImg className={EngagingMenuPageStyle.engagingMenuImg} />
                </ScrollAnimation>
            </Col>
        </Row>
        {/* Section 2 Content */}
        <Row className={EngagingMenuPageStyle.engagingMenuRow2}>
            <Col className={EngagingMenuPageStyle.engagingMenuSec1Col3} xs={12}>
                <h3 className={EngagingMenuPageStyle.sectionTitleLeftAlign}>{data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent2.subtitle.subtitle}</h3>
                <div className={EngagingMenuPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent2.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
        <Row className={EngagingMenuPageStyle.engagingMenuRow3}>
            <Col className={EngagingMenuPageStyle.engagingMenuSec1Col4} md={5} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <PhotographyImg className={EngagingMenuPageStyle.photographyImg} />
                </ScrollAnimation>
            </Col>
        {/* Section 3 Content */}
            <Col className={EngagingMenuPageStyle.engagingMenuSec1Col5} md={7} sm={6}>
                <h3 className={EngagingMenuPageStyle.sectionTitleLeftAlign}>{data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent3.subtitle.subtitle}</h3>
                <div className={EngagingMenuPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulEngagingMenuPage.engagingMenuReference.sectionContent3.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
         <Row className={EngagingMenuPageStyle.engagingMenuLinksRow1}>
            <Col className={EngagingMenuPageStyle.engagingMenuLinksCol} md={12}>
                <Link to="/essentials" className={EngagingMenuPageStyle.engagingMenuLinks}>The Essentials</Link>
                <Link to="/mobile-first" className={EngagingMenuPageStyle.engagingMenuLinks}>Mobile First</Link>
                <span className={EngagingMenuPageStyle.activeLink}>Engagaing Menu</span>
                <Link to="/convenient-booking" className={EngagingMenuPageStyle.engagingMenuLinks}>Convenient Booking</Link>
            </Col>
        </Row>
        <Row className={EngagingMenuPageStyle.engagingMenuLinksRow2}>
        <Col className={EngagingMenuPageStyle.engagingMenuLinksMobileCol} xs={6}>
                <Link to="/mobile-first" className={EngagingMenuPageStyle.engagingMenuLinksMobile}><FontAwesomeIcon icon={faArrowLeft} className={EngagingMenuPageStyle.chevronIcons} /> Previous</Link>
            </Col>
            <Col className={EngagingMenuPageStyle.engagingMenuLinksMobileCol} xs={6}>
                <Link to="/convenient-booking" className={EngagingMenuPageStyle.engagingMenuLinksMobile}>Next <FontAwesomeIcon icon={faArrowRight} className={EngagingMenuPageStyle.chevronIcons} /></Link>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default EngagingMenuSec1